module.exports = __webpack_public_path__ + "img/icon_edit_his.7bea0393.svg";